import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dynamic scroll" }
const _hoisted_2 = { class: "dynamic__title" }
const _hoisted_3 = { class: "dynamic__chart" }

import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useFilesStore} from "@/stores/files";
import type {Month} from "@/types/files";
import {DynamicByMonthProps} from "@/types/analytics";
import {getDistrictName} from "@/composables/functions/getDistrictName";
import {getRegionName} from "@/composables/functions/getRegionName";


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicByMonth',
  props: {
    dynamic: {},
    activeType: {},
    selectedRegion: {},
    selectedDistrict: {}
  },
  setup(__props: any) {

const props = __props;

const filesStore = useFilesStore();
const { selectedMonth, selectedYear } = storeToRefs(filesStore);

// Порядок месяцев
const monthsOrder: Month[] = [
  "january", "february", "march", "april", "may", "june",
  "july", "august", "september", "october", "november", "december"
];

const monthNames: Record<string, string> = {
  january: "янв",
  february: "фев",
  march: "мар",
  april: "апр",
  may: "май",
  june: "июн",
  july: "июл",
  august: "авг",
  september: "сен",
  october: "окт",
  november: "ноя",
  december: "дек"
};

// Месяцы для отображения с учётом выбранного года
const monthsToShow = computed(() => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonthIndex = now.getMonth(); // 0 = январь, 11 = декабрь

  // Если выбран прошлый год — все 12 месяцев
  if (selectedYear.value < currentYear) {
    return monthsOrder;
  }

  // Если текущий год — месяцы до текущего включительно
  return monthsOrder.slice(0, currentMonthIndex + 1);
});

// Данные для отображения
const chartData = computed(() => {
  const dynamicData = props.dynamic;
  if (!dynamicData) return [];

  return monthsToShow.value.map(month => ({
    month,
    value: dynamicData[month] || 0,
    label: monthNames[month]
  }));
});

// Динамическая ширина баров в зависимости от количества месяцев
const barWidth = computed(() => {
  const count = chartData.value.length;
  if (count <= 4) return 42;
  if (count <= 6) return 36;
  if (count <= 8) return 30;
  if (count <= 10) return 26;
  return 22;
});

const maxValue = computed(() => {
  if (chartData.value.length === 0) return 1;
  return Math.max(...chartData.value.map(d => d.value));
});

const minValue = computed(() => {
  if (chartData.value.length === 0) return 0;
  return Math.min(...chartData.value.map(d => d.value));
});

const getBarHeight = (value: number) => {
  if (maxValue.value === minValue.value) return 50;
  const range = maxValue.value - minValue.value;
  const normalizedValue = value - minValue.value;
  // Используем 80% высоты для диапазона, 20% - минимальная высота
  return 20 + (normalizedValue / range) * 80;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode(" Динамика по месяцам ", -1)),
      (__props.activeType === 'russia')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" (Россия) ")
          ], 64))
        : (__props.activeType === 'district')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" (" + _toDisplayString(_unref(getDistrictName)(__props.selectedDistrict)) + ") ", 1)
            ], 64))
          : (__props.activeType === 'region')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" (" + _toDisplayString(_unref(getRegionName)(__props.selectedRegion)) + ") ", 1)
              ], 64))
            : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.month,
          class: "dynamic__block"
        }, [
          _createElementVNode("div", {
            class: "dynamic__bar-container",
            style: _normalizeStyle({ width: `${barWidth.value}px` })
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["dynamic__value", {'dynamic__value--active': _unref(selectedMonth) === item.month}])
            }, _toDisplayString(item.value), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["dynamic__bar", {'dynamic__bar--active': _unref(selectedMonth) === item.month}]),
              style: _normalizeStyle({ height: `${getBarHeight(item.value)}%` })
            }, null, 6)
          ], 4),
          _createElementVNode("span", {
            class: _normalizeClass(["dynamic__label", {'dynamic__label--active': _unref(selectedMonth) === item.month}])
          }, _toDisplayString(item.label), 3)
        ]))
      }), 128))
    ])
  ]))
}
}

})